module.exports = __webpack_public_path__ + "static/img/1.86d1235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/eng/1.png
// module id = 2xO9
// module chunks = 0